/*
*
* File JS Atomo Video
*
*/

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './index.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const video = () => {

    // Trova tutti i controlli custom dei video sulla pagina
    const allControls = document.querySelectorAll('.video-custom-controls');

    if (allControls.length === 0) {
        return;
    }
    
    allControls.forEach(controls => {
        const videoId = controls.dataset.controlsFor;
        const video = document.getElementById(videoId);

        if (video) {
            const playBtn = controls.querySelector('.play-btn');
            const pauseBtn = controls.querySelector('.pause-btn');
            const loopBtn = controls.querySelector('.loop-btn');
            
            // Funzione per aggiornare la visibilità dei bottoni play/pausa
            const updatePlayPauseButtons = () => {
                if (video.paused) {
                    playBtn.style.display = 'flex';
                    pauseBtn.style.display = 'none';
                } else {
                    playBtn.style.display = 'none';
                    pauseBtn.style.display = 'flex';
                }
            };

            // Eventi per aggiornare lo stato
            video.addEventListener('play', updatePlayPauseButtons);
            video.addEventListener('pause', updatePlayPauseButtons);

            // Click listeners
            playBtn.addEventListener('click', () => {
                video.play();
            });

            pauseBtn.addEventListener('click', () => {
                video.pause();
            });

            loopBtn.addEventListener('click', () => {
                video.loop = !video.loop;
                loopBtn.classList.toggle('active', video.loop);
            });

            // Stato iniziale
            updatePlayPauseButtons();
        }
    });
}


export default video;

//--------------------------------------------------------------------//